import { AssessmentQuestionResponseVisibility } from "types/graphql-schema";

import Tooltip from "@components/tooltip/tooltip";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";
import { classNames } from "@helpers/css";

const QuestionVisibilityIcon = ({
  visibility,
}: {
  visibility: AssessmentQuestionResponseVisibility;
}) => {
  const visibilityClassName =
    "flex items-center gap-2 rounded-md px-2 py-1 text-gray-600 text-xs";
  return visibility ===
    AssessmentQuestionResponseVisibility.HiddenFromSubject ? (
    <Tooltip text="This question is hidden from the subject.">
      <div className={classNames(visibilityClassName)}>
        <TopicflowIcon type="eyeOff" className="text-amber-700 h-4 w-4" />
      </div>
    </Tooltip>
  ) : (
    <Tooltip text="This question is visible to the subject.">
      <div className={classNames(visibilityClassName)}>
        <TopicflowIcon type="eye" className="text-emerald-600 h-4 w-4" />
      </div>
    </Tooltip>
  );
};
export default QuestionVisibilityIcon;
